import { Select } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TrendsIntervalSize } from '../../../types/phlebotomist-dashboard';

interface IIntervalSizeSelectProps {
  value: TrendsIntervalSize;
  onChange: (value: TrendsIntervalSize) => void;
}

export const IntervalSizeSelect: FC<IIntervalSizeSelectProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation('dashboard.PhlebotomistDashboard');

  const options = [
    { value: 'day', label: t('intervalSize.day', 'Day') },
    { value: 'week', label: t('intervalSize.week', 'Week') },
    { value: 'month', label: t('intervalSize.month', 'Month') },
    { value: 'quarter', label: t('intervalSize.quarter', 'Quarter') },
    { value: 'year', label: t('intervalSize.year', 'Year') },
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      style={{ width: '100%', minWidth: 0 }}
    />
  );
};

export default IntervalSizeSelect;
